import { lazyLoad } from 'utils/loadable';

export const SalesDemoToolbar = lazyLoad(
  () => import('./SalesDemoToolbar'),
  module => module.SalesDemoToolbar,
);

export const NurturingMetricsComponent = lazyLoad(
  () => import('./NurturingMetricsComponent'),
  module => module.NurturingMetricsComponent,
);

export const SalesDemoDataGridComponent = lazyLoad(
  () => import('./SalesDemoDataGridComponent'),
  module => module.SalesDemoDataGridComponent,
);

export const NurturingHistoryComponent = lazyLoad(
  () => import('./NurturingHistoryComponent'),
  module => module.NurturingHistoryComponent,
);

export const NurturingHistoryCardComponent = lazyLoad(
  () => import('./NurturingHistoryCardComponent'),
  module => module.NurturingHistoryCardComponent,
);

export const LeadDetailsComponent = lazyLoad(
  () => import('./LeadDetailsComponent'),
  module => module.LeadDetailsComponent,
);

export const MetricComponent = lazyLoad(
  () => import('./MetricComponent'),
  module => module.MetricComponent,
);
